import { Product } from '@/services'

import {
  chunkerizeArray,
  truthy,
} from '@/helpers/'

import { log } from '@/services/Log'
import { BigCommerceCart, PhysicalItem } from '@/types/Cart'
import { ProductType } from '@/types'


export const generateLineItemsFromCheckout = async (cart: {lineItems: {
  physicalItems: PhysicalItem[]
}}) => {
  log('generateLineItemsFromCheckout START', { cart })
  if (!cart) {
    return []
  }
  const lineItems = cart.lineItems.physicalItems || []
  const lineItemToSku: (p: PhysicalItem) => string = ({ url, sku }) => {
    const skuFromUrl = `${url}`.split('?')[0].split('-').pop()
    return !!skuFromUrl ? skuFromUrl : sku
  }
  const uniqueSkus = [...(new Set(
    lineItems
      .filter(({ productId, sku }) => !!productId && !!sku)
      .map(lineItemToSku)
  ))]
  const productSkus = chunkerizeArray(uniqueSkus, 25)
  // Request products skus from search api in chunks of 25
  const chunkerizedProducts: ProductType[][] = await Promise.all(productSkus.map(Product.bySkus))
  
  const skusData: ProductType[] = Array.prototype.concat.apply([], chunkerizedProducts);
  const itemMetadata: { [key: string]: ProductType } = {}
  skusData.forEach(p => {
    itemMetadata[p.id] = p
    itemMetadata[p.sku] = p
    p.variants.forEach(v => itemMetadata[v.sku] = p)
  })


  const ungroupedItems = lineItems.map((lineItem) => {
    const product = itemMetadata[lineItem.sku]
    const isFurniture = truthy(product?.warranty?.variants?.[lineItem.sku]?.is_white_glove)
    const isDigital = truthy(product?.warranty?.additional?.is_digital)
    const productVariant = product?.variants?.find(({ sku }) => lineItem.sku === sku)
    const imageUrl = productVariant?.images?.[0]?.url_square || lineItem?.imageUrl
    const url = `/p-${`${product?.name || 'product'}`.toLowerCase().replace(/([^a-z\-])/g, ' ').trim().split(' ')[0]}-${product?.sku}?sku=${lineItem.sku}`
    const isReturnable = product?.warranty?.variants?.[lineItem.sku]?.is_returnable
    return {
      ...lineItem,
      url,
      imageUrl,
      originalPrice: lineItem.salePrice,
      isFurniture,
      isReturnable,
      isDigital,
    }
  })

  const response = ungroupedItems.sort( // Sorting furniture to the end to match output from LineItemsFromCheckout
    (item1, item2) => (
      // eslint-disable-next-line no-nested-ternary
      (!item1.isFurniture && item2.isFurniture)
        ? -1
        : (item1.isFurniture && !item2.isFurniture)
          ? 1
          : 0
    ),
  )

  log('generateLineItemsFromCheckout END', { response })
  return response
}
